module.exports = __webpack_public_path__ + "static/media/img_fenlei03.b582aeb9.png";